import React from 'react';
import Icon from './Icon';
import SectionHeading from './SectionHeading';
import { capabilities } from '../mock/mock';

export default function TechnologySection() {
  return (
    <section className="relative max-w-7xl mx-auto px-5 md:px-8 section-pad">
      <SectionHeading
        eyebrow="Technology & Tracking"
        title={<span>Powered by <span className="text-gradient">Performance Technology.</span></span>}
        subtitle="MMP tracking, attribution and real-time optimization power every campaign we run."
      />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {capabilities.map((c) => (
          <div key={c.title} className="reveal glass glass-hover rounded-2xl p-6">
            <div className="w-11 h-11 rounded-xl bg-[#2563eb]/12 grid place-items-center text-[#2563eb] mb-4">
              <Icon name={c.icon} size={21} />
            </div>
            <h3 className="font-display text-base font-semibold text-slate-900 mb-1.5">{c.title}</h3>
            <p className="text-sm text-slate-500 leading-relaxed">{c.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
